/** Tab values that should remain indexable on entity pages. */
const INDEXABLE_PAGE_TABS = new Set([
  'overview',
  'thread',
  /** Region / municipality discussion tab */
  'discussion',
])

/** Whether a tab URL should carry `noindex, follow` (all tabs except overview and thread-like tabs). */
export const shouldNoindexPageTab = (tab: string): boolean =>
  !INDEXABLE_PAGE_TABS.has(tab)
